
export function unifiedBrowserCheck (browser) {

  const allSupportedVersions = browser.os.includes('iOS') ? supportedIos : supportedStandard
  const supportedVersion = allSupportedVersions[browser.platform][browser.name]

  if (!supportedVersion) {
    return 'hard-fail:bad-browser'
  }

  if (browser.versionNumber < supportedVersion.hardFail) {
    return 'hard-fail:old-browser'
  }

  if (browser.versionNumber < supportedVersion.softFail) {
    return 'soft-fail:old-browser'
  }

  return 'pass'

}

const supportedStandard = {
  'desktop': {
    'chrome': {
      'softFail': 70,
      'hardFail': 65
    },
    'firefox': {
      'softFail': 64,
      'hardFail': 63
    },
    'opera': {
      'softFail': 56,
      'hardFail': 50
    },
    'safari': {
      'softFail': 12.1,
      'hardFail': 11
    },
    'microsoft edge': {
      'softFail': 79,
      'hardFail': 70
    }
  },
  'tablet': {
    'chrome': {
      'softFail': 70,
      'hardFail': 65
    },
    'firefox': {
      'softFail': 64,
      'hardFail': 63
    },
    'opera': {
      'softFail': 44,
      'hardFail': 44
    },
    'safari': {
      'softFail': 12.1,
      'hardFail': 11
    },
    'samsung internet for android': {
      'softFail': 11,
      'hardFail': 9
    }
  },
  'mobile': {
    'chrome': {
      'softFail': 70,
      'hardFail': 65
    },
    'firefox': {
      'softFail': 64,
      'hardFail': 63
    },
    'opera': {
      'softFail': 44,
      'hardFail': 44
    },
    'samsung internet for android': {
      'softFail': 11,
      'hardFail': 9
    },
    'safari': {
      'softFail': 12.1,
      'hardFail': 11
    }
  }
}

const supportedIos = {
  'tablet': {
    'safari': {
      'softFail': 12.1,
      'hardFail': 11
    }
  },
  'mobile': {
    'safari': {
      'softFail': 12.1,
      'hardFail': 11
    }
  }
}
